// extracted by mini-css-extract-plugin
export var container = "Investment-module--container--40936";
export var heroCopy = "Investment-module--heroCopy--0faef";
export var heroImage = "Investment-module--heroImage--c4ad6";
export var heroImageContainer = "Investment-module--heroImageContainer--680c1";
export var hexOverlappingContainer = "Investment-module--hexOverlappingContainer--ba506";
export var investmentEcosystemSection = "Investment-module--investmentEcosystemSection--548a5";
export var investmentFaqAccordion = "Investment-module--investmentFaqAccordion--a04c1";
export var investmentFaqHeader = "Investment-module--investmentFaqHeader--133a8";
export var investmentHeaderImage = "Investment-module--investmentHeaderImage--1a5ef";
export var keepEarnGrowContainer = "Investment-module--keepEarnGrowContainer--1bd82";
export var toFaqButton = "Investment-module--toFaqButton--32cc6";